import { UserActions } from "@dots-crm/contracts/client";

export const USER_ENDPOINTS_URLS = {
  readProfile: "users/profile",
  readMany: ({
    page,
    limit,
    search,
  }: UserActions["readMany"]["query"]) =>
    `users?page=${page}&limit=${limit}${search ? `&search=${search}` : ""}`,
  readOne: ({ userId }: UserActions["readOne"]["params"]) => `users/${userId}`,
  create: "users",
  update: ({ userId }: UserActions["update"]["params"]) => `users/${userId}`,
  delete: ({ userId }: UserActions["delete"]["params"]) => `users/${userId}`,
  approve: ({ userId }: UserActions["approve"]["params"]) => `users/${userId}/approve`,
};

export const USER_TAGS = {
  users: "users",
  user: "user",
  user_profile: "user-profile",
};
